import React, { Component } from 'react';
// import PropTypes from 'prop-types'

import Button from '../button/Button.jsx';
import CheckboxEditor from '../checkbox-editor/CheckboxEditor.jsx';

import s from './ImportExportView.module.scss';

export default class ImportExportView extends Component {
    constructor(props) {
        super(props);
        this.state = { checkboxChecked: false };
    }

    onFileBrowse = () => {
        this.fileInput.click();
    };

    render() {
        return (
            <div className={s.importExportView}>
                <div className={s.title}>Data Exchange Demo</div>
                <div className={s.subtitle}>Below you can import floorplans and export both the POI and other data related to this venue</div>
                <div className={s.sectionTitle}>IMPORT FLOORPLAN</div>
                <div className={s.sectionSubtitle}>
                    If you have an existing .DWG, .PDF, or .AI file of your floor plan, you can upload it to the Wayfinder Venue Management System for processing. Please include instructions below.
                </div>
                <div className={s.importRow}>
                    <div className={s.fileBox}>
                        <div className={s.uploadInfo}>
                            <img alt="Upload Dwg" src="https://content.locuslabs.com/vms-ui/upload-icons/upload-icon-dwg.png" />
                            <img alt="Upload Pdf" src="https://content.locuslabs.com/vms-ui/upload-icons/upload-icon-pdf.png" />
                            <img alt="Upload Ai" src="https://content.locuslabs.com/vms-ui/upload-icons/upload-icon-ai.png" />
                            <div>
                                Drag or{' '}
                                <button type="button" onClick={this.onFileBrowse}>
                                    browse
                                </button>{' '}
                                to add floor plans
                            </div>
                            <input
                                type="file"
                                ref={input => {
                                    this.fileInput = input;
                                }}
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>
                    <textarea className={s.instructionsBox} placeholder="Type instructions here..." />
                </div>
                <Button label="IMPORT FLOOR PLANS" className={s.importButton} disabled>
                    IMPORT FLOOR PLANS
                </Button>
                <hr />
                <div className={s.exportRow}>
                    <div className={s.exportBox}>
                        <div className={s.upper}>
                            <div className={s.sectionTitle}>EXPORT CSV FILE OF POIS</div>
                            <div className={s.sectionSubtitle}>
                                Download all &quot;active&quot; points of interest for this venue. You can also use our <span className={s.linkish}>REST API</span> for real-time POI data access.
                            </div>
                            <CheckboxEditor
                                value={this.state.checkboxChecked}
                                onValueChanged={value => {
                                    this.setState({ checkboxChecked: value });
                                }}
                                label="Include non-active POIs in the exported data"
                            />
                        </div>
                        <div className={s.uploadInfo}>
                            <img alt="Upload Csv" src="https://content.locuslabs.com/vms-ui/upload-icons/upload-icon-csv.png" />
                            <div>
                                <button type="button">Download</button>
                            </div>
                        </div>
                    </div>
                    <div className={s.exportBox}>
                        <div className={s.upper}>
                            <div className={s.sectionTitle}>EXPORT IMDF FILE</div>
                            <div className={s.sectionSubtitle}>
                                This file format includes map geometry and point of interest data in Apple&apos;s Indoor Mapping Data Format (IMDF),
                                <br />
                                formerly known as Apple Venue Format (AVF).
                            </div>
                        </div>
                        <div className={s.uploadInfo}>
                            <img alt="Upload Imd" src="https://content.locuslabs.com/vms-ui/upload-icons/upload-icon-imdf.png" />
                            <div>
                                <button type="button">Download</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
